import { render, staticRenderFns } from "./SumaryPayment.vue?vue&type=template&id=322e9642&scoped=true"
import script from "./SumaryPayment.vue?vue&type=script&lang=js"
export * from "./SumaryPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e9642",
  null
  
)

export default component.exports